import { observable, action } from 'mobx'

class NoAccountModalStore {
  @observable content = ''

  @action.bound setContent(content) {
    this.content = content
    document.querySelector('#NoAccountModal').classList.add('md-show') 
  }
}

export default new NoAccountModalStore()



// WEBPACK FOOTER //
// ./src/stores/noAccountModalStore.js